/**
 * Whether the /stores/[cName] homepage still needs to show `HomePageLoadingState` because its
 * dispensary hasn't loaded yet.
 */
export function needsHomePageLoadingState(dispensary: unknown): boolean {
  return !dispensary;
}
